import React, { useState } from "react"
import { useTracking } from "react-tracking"
import { ConfiguratorCard } from "./components/card-wrapper"
import { configuratorType } from "./model"
import { Signature } from "./components/cards/signature"
import { Images } from "./components/cards/images"
import { defaultBrandingImages } from "./components/cards/images/model"
import { Actions } from "../actions"
import { getConfiguratorTrackingString } from "./functions"

import "./style.scss"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Configurator = (props: any) => {
    const { mobileDisplay, formik, active, setActive, template, updateTemplate, submit } = props
    const [images, setImage] = useState(defaultBrandingImages)
    const { trackEvent } = useTracking()

    const configuratorConfig: CardConfig[] = [
        {
            id: "signature",
            children: <Signature formik={formik} />,
        },
        {
            id: "images",
            children: (
                <Images
                    formik={formik}
                    template={template}
                    updateTemplate={updateTemplate}
                    images={images}
                    callback={setImage}
                />
            ),
        },
        { id: "layout", disabled: true },
        { id: "social", disabled: true },
        { id: "disclaimer", disabled: true },
    ]

    function changeCard(value: configuratorType) {
        trackEvent({
            event: "genericEvent",
            category: "click",
            action: "click configure heading",
            label: getConfiguratorTrackingString(value),
        })
        setActive(value)
    }

    return (
        <div data-testid="cnf" className={`cnf ${!mobileDisplay ? "mbl-hidden" : ""}`}>
            {configuratorConfig.map((item, index) => {
                return (
                    <ConfiguratorCard
                        key={index}
                        id={item.id}
                        active={active === item.id}
                        disabled={item.disabled}
                        changeCard={changeCard}
                    >
                        {/* The mobile conditional is present to ensure they are re-rendered when toggling between
                            mobile views so that it can re-focus on the input fields correctly. */}
                        {mobileDisplay && item.children}
                    </ConfiguratorCard>
                )
            })}
            <Actions mobileDisplay={mobileDisplay} submit={submit} />
        </div>
    )
}

interface CardConfig {
    id: configuratorType
    disabled?: boolean
    children?: React.ReactNode
}
